<script setup lang="ts">
  defineOptions({
    inheritAttrs: false,
  });

  interface Props {
    header?: string,
    headerType?: string,
    categories?: object[],
    link?: string,
    enableAutoplay?: boolean,
    timeAutoplay?: number,
    speed?: number,
  }

  defineProps<Props>();
</script>
<template>
  <SfSection v-if="categories" :title="header" :headerType :link>
    <CategoriesCarousel :categories :enableAutoplay :timeAutoplay :speed />
  </SfSection>
</template>
